import { secureStorage, StorageKeys } from "@services/secureStorage.service";
import { baseApi } from "@store/apis";

import type { UpdateRequest } from "./models";


const UpdateIsClaimed = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    UpdateIsClaimed: builder.mutation({
      // invalidatesTags: ["Challenges"],
      query: ({ challengeId }: UpdateRequest) => ({
        url: "UpdateIsClaimed",
        params: {
          ChallengeId: challengeId,
          UserId: secureStorage.get<string>(StorageKeys.USER_ID),
        },
        method: "PUT",
      }),
      transformResponse: (response: { result: boolean }) => response.result,
    }),
  }),
});
export const { useUpdateIsClaimedMutation } = UpdateIsClaimed;

